import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Row, Spin, Tooltip } from 'antd';
import React, { ReactElement } from 'react';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { ReactComponent as TickIcon} from '../../../../../../../assets/images/svg/Card_Selected_icon.svg';
import { ReactComponent as MemberAccount } from '../../../../../../../assets/images/svg/Member_Account_icon.svg';
import { maxLength } from '../../../../../../../shared/constants/commonConstants';

const PolicySearchCard = ({ policySearchResults, isSelected, index, loading, disabled, isConfirmed }: any): ReactElement => {
  useSmoothScroll('scroll-policy');
  const {
    productName, memberId, productId, payerName,
  } = policySearchResults;

  return <Tooltip
      title={disabled ? 'This card cannot be selected as the payer is not configured for this hospital' : 'Click on card to select'}
    >
    <Card data-testid="benefCard" style={{'opacity' : disabled ? '0.5' : '1'}}
    className={`scroll-policy panel-styles ${isConfirmed && 'benef-search-card'} card-selected mb-md`} hoverable={true}>
    <Col className="selected-Svg-Icon">
    {isConfirmed && <TickIcon/>}
    </Col>
      <Row className="beneficiary-card">
      <Col md={3} className="selectedicon"><MemberAccount/></Col>

        <Col md={20} style={{marginLeft: '8px'}}>
          <Row className="m-b-5">
            <Col md={10} className="text-elipsis label-title fsize_sm">
              Payer Name: </Col><Col md={10} className="label-title fsize_sm"> {payerName || '-'}</Col>
          </Row>
          <Row className="m-b-5">
            <Col md={10} className="text-elipsis label-title fsize_sm">Product Name: </Col>
            <Col md={10} className="label-title fsize_sm"> {productName?.length >
              maxLength ? `${productName?.slice(0, maxLength)}...` : productName || '-'}</Col>
          </Row>
            <Row className="m-b-5">
              <Col md={10} className="text-elipsis label-title fsize_sm">
                Member Id:
              </Col>
              <Col md={10} className="label-title fsize_sm">{memberId || '-'}</Col>
            </Row>
            <Row className="m-b-5">
              <Col md={10} className="text-elipsis label-title fsize_sm">
               Product Id:
              </Col>
              <Col md={10} className="text-elipsis label-title fsize_sm">{productId || '-'}</Col>
            </Row>
        </Col>
      </Row>

    <Row justify="end">
        {
          isSelected && loading &&
            <Spin indicator={<LoadingOutlined style={{ fontSize: 18, marginTop: '-20px' }} spin={true} />} />
        }
    </Row>
  </Card></Tooltip>;
};

export default PolicySearchCard;
